import React from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { ForwardChatContextImport } from "../../../../provider/chats/chats/forward_chat/ForwardChatContextProvider";
import Center from "../../../../widget/common/ui/Center";
import Loader from "../../../../widget/common/ui/Loader";
import NoData from "../../../../widget/common/ui/NoData";
import { Listing, ListItem } from "../../../../widget/common/ui/Listing";
import Div from "../../../../widget/common/ui/Div";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { textCase } from "../../../../service/ui/UI";
import { LogoRound } from "../../../../widget/common/ui/Logo";
import { CheckBoxRound } from "../../../../widget/common/ui/Checkbox";

const ForwardChatList = () => {
  const type: number = ResponsiveDeviceType();

  const { profileList, handleClickProfile, selectedProfiles } =
    ForwardChatContextImport();

  return (
    <>
      {profileList == null ? (
        <Center className="h-100 py-5">{Loader.normal()}</Center>
      ) : profileList.length === 0 ? (
        <Center className="h-100  py-5">
          <NoData />
        </Center>
      ) : (
        <Listing fixedHieght={type === 3 ? true : false}>
          {profileList.map((profile, key) => (
            <ListItem key={key}>
              <div
                role="button"
                className="d-flex align-items-center justify-content-between w-100"
                onClick={() => handleClickProfile(profile)}
              >
                <Div className="d-flex align-items-center">
                  <Div>
                    <LogoRound
                      url={profile?.logo!}
                      isProfile={true}
                      name={profile?.name!}
                      size={type === 2 ? 55 : 43}
                    />
                  </Div>
                  <Div className="ps-3 w-100">
                    <TextBlock
                      fontName="medium"
                      fontSize="16_17"
                      textColor="black"
                      maxLine={1}
                    >
                      {textCase(profile?.name!)}
                    </TextBlock>
                    <TextBlock
                      fontName="book"
                      fontSize="14_15"
                      textColor="theme-sublabel"
                      maxLine={1}
                    >
                      {textCase(profile?.title!)}
                    </TextBlock>
                  </Div>
                </Div>
                <Div>
                  <CheckBoxRound
                    status={selectedProfiles.includes(profile.conv_id!)}
                  />
                </Div>
              </div>
            </ListItem>
          ))}
        </Listing>
      )}
    </>
  );
};

export default ForwardChatList;
